import { render, staticRenderFns } from "./Hhwhc.vue?vue&type=template&id=066f3913&scoped=true&"
import script from "./Hhwhc.vue?vue&type=script&lang=js&"
export * from "./Hhwhc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f3913",
  null
  
)

export default component.exports